import { GETREGISTEREDDEVICEDETAILS, GETREGISTEREDDEVICEDETAILS_ERROR, GETREGISTEREDDEVICEDETAILS_HIDE_ERROR, GETREGISTEREDDEVICEDETAILS_START_LOADER, GETREGISTEREDDEVICEDETAILS_STOP_LOADER } from "../interface/IGetRegisteredDevice";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const GetRegisteredDeviceReducer = (state = initState, action) => {
    switch (action.type) {
        case GETREGISTEREDDEVICEDETAILS:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case GETREGISTEREDDEVICEDETAILS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case GETREGISTEREDDEVICEDETAILS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case GETREGISTEREDDEVICEDETAILS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case GETREGISTEREDDEVICEDETAILS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default GetRegisteredDeviceReducer;
